/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
console.log("Hello World! (from sd-viblock-sd-product-list block)");
/* eslint-enable no-console */

document.addEventListener('DOMContentLoaded', function () {
	const productGroups = document.querySelectorAll('.product-family-group');

	productGroups.forEach(group => {
		const productList = group.querySelector('.product-list');
		const prevBtn = group.querySelector('.slideshow-prev');
		const nextBtn = group.querySelector('.slideshow-next');

		if (!productList || !prevBtn || !nextBtn) return;

		nextBtn.addEventListener('click', () => {
			const scrollAmount = productList.clientWidth;
			productList.scrollBy({ left: scrollAmount, behavior: 'smooth' });
		});

		prevBtn.addEventListener('click', () => {
			const scrollAmount = productList.clientWidth;
			productList.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
		});

		// Update button visibility based on scroll position
		const updateButtons = () => {
			const isAtStart = productList.scrollLeft <= 0;
			const isAtEnd = productList.scrollLeft >= productList.scrollWidth - productList.clientWidth - 10;

			prevBtn.style.display = isAtStart ? 'none' : 'flex';
			nextBtn.style.display = isAtEnd ? 'none' : 'flex';
		};

		productList.addEventListener('scroll', updateButtons);
		updateButtons(); // Initial state
	});
});
